import { insetObjectTable } from '../../utils/utils'
import {
  GET_COMPTE_TIERS,
  GET_COMPTE_TIERS_SUCCESS,
  GET_COMPTE_TIERS_FAILURE,
  ADD_COMPTE_TIERS,
  ADD_COMPTE_TIERS_FAILURE,
  ADD_COMPTE_TIERS_SUCCESS,
  UPDATE_COMPTE_TIERS,
  UPDATE_COMPTE_TIERS_SUCCESS,
  UPDATE_COMPTE_TIERS_FAILURE,
  GET_COMPTE_TIERS_LIST_MORE,
  GET_COMPTE_TIERS_LIST_MORE_SUCCESS,
  GET_COMPTE_TIERS_LIST_MORE_FAILURE,
  PAGE_CHANGED,
  PAGE_LIMIT_CHANGED,
  REMOVE_ERROR,
  RESET_SUCCESS_ACTION,
  RESET_CONFIG,
  SEARCH_COMPTE_TIERS,
} from './constants'
import initialState from './initialState'

export default (state = initialState(), action) => {
  if (action.type === GET_COMPTE_TIERS) {
    return {
      ...state,
      compteTiers: [],
      isLoadingCompteTiersList: true,
    }
  }

  if (action.type === GET_COMPTE_TIERS_SUCCESS) {
    const { data, total } = action.payload.data
    return {
      ...state,
      compteTiers: data,
      isLoadingCompteTiersList: false,
      compteTiersCount: total,
    }
  }

  if (action.type === GET_COMPTE_TIERS_FAILURE) {
    const { response } = action.payload?.data

    return {
      ...state,
      isLoadingCompteTiersList: false,
      errorMessage: response?.data?.message || ' Veuillez réessayer plus tard ',
      isErrorFetch: true,
    }
  }

  if (action.type === GET_COMPTE_TIERS_LIST_MORE) {
    return {
      ...state,
    }
  }
  if (action.type === GET_COMPTE_TIERS_LIST_MORE_SUCCESS) {
    return {
      ...state,
      compteTiers: [...state.compteTiers, ...action.payload?.data?.data],
      compteTiersCount: action.payload.data?.count || 0,
    }
  }

  if (action.type === GET_COMPTE_TIERS_LIST_MORE_FAILURE) {
    const { response } = action.payload?.data
    return {
      ...state,
      errorMessage: response?.data?.message || ' Veuillez réessayer plus tard ',
    }
  }

  if (action.type === PAGE_CHANGED) {
    const { offset } = action.payload
    const filter = { ...state.filter }
    filter.offset = offset
    return {
      ...state,
      filter,
    }
  }

  if (action.type === PAGE_LIMIT_CHANGED) {
    const { limit } = action.payload
    const filter = { ...state.filter }
    filter.limit = limit
    filter.offset = 0
    return {
      ...state,
      filter,
    }
  }

  if (action.type === REMOVE_ERROR) {
    return {
      ...state,
      errorMessage: null,
      isErrorFetch: false,
    }
  }

  if (action.type === RESET_SUCCESS_ACTION) {
    return {
      ...state,
      success: false,
      isSuccessRefresh: false,
    }
  }

  if (action.type === RESET_CONFIG) {
    //rest
    return {
      ...state,
      errorMessage: null,
      isErrorFetch: false,
      isLoadingCompteTiersAction: false,
      success: false,
      isSuccessRefresh: false,

      filter: {
        limit: 25,
        offset: 0,
      },
    }
  }

  if (action.type === SEARCH_COMPTE_TIERS) {
    const { search } = action.payload
    return {
      ...state,
      filter: {
        ...state.filter,
        limit: 25,
        offset: 0,
        query: search,
      },
    }
  }

  if (action.type === ADD_COMPTE_TIERS) {
    return {
      ...state,
      isLoadingCompteTiersAction: true,
    }
  }
  if (action.type === ADD_COMPTE_TIERS_SUCCESS) {
    return {
      ...state,
      isLoadingCompteTiersAction: false,
      success: true,
      isSuccessRefresh: true,
    }
  }

  if (action.type === ADD_COMPTE_TIERS_FAILURE) {
    const { response } = action.payload.data
    return {
      ...state,
      isLoadingCompteTiersAction: false,
      errorMessage: response?.data?.message || ' Veuillez réessayer plus tard ',
    }
  }

  if (action.type === UPDATE_COMPTE_TIERS) {
    return {
      ...state,
      isLoadingCompteTiersAction: true,
    }
  }
  if (action.type === UPDATE_COMPTE_TIERS_SUCCESS) {
    const { data } = action.payload.data

    const compteTiersIndex = state.compteTiers.map((el) => el.id).indexOf(data.id)

    return {
      ...state,
      compteTiers: [...insetObjectTable(state.compteTiers, data, compteTiersIndex)],
      isLoadingCompteTiersAction: false,
      success: true,
    }
  }

  if (action.type === UPDATE_COMPTE_TIERS_FAILURE) {
    const { response } = action.payload?.data
    return {
      ...state,
      isLoadingCompteTiersAction: false,
      success: false,
      errorMessage: response?.data?.message || ' Veuillez réessayer plus tard ',
    }
  }

  return state
}
